import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import RecommendProduct from "./RecommendProduct";
import { setRecommendList } from "../../../../store/recommendProduct";
import apiService from "../../../../api/api.service";
import { SHOP } from "../../../../config/config";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const RecommendProductList = ({ order }) => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.recommendProducts);
  const { productRecommend: settings } = useSelector((state) => state.settings);
  const line_items =
    typeof order?.line_items === "string"
      ? JSON.parse(order.line_items)
      : order.line_items;
  const listProductID = line_items?.map((item) => item?.product_id?.toString());

  useEffect(() => {
    const fetchRecommendList = async () => {
      try {
        const response = await apiService.get("getRecommendProducts", {
          settingRecommend: {
            ...settings,
            tags: settings.tags && settings.tags?.length ? settings.tags : [],
            product_type:
              settings.productType && settings.productType?.length
                ? settings.productType
                : [],
          },
        });
        if (response.data.state === 1) {
          dispatch(setRecommendList(response.data.products));
          return;
        }
      } catch (err) {
        // console.log(err);
      }
    };

    fetchRecommendList();
  }, [dispatch]);

  useEffect(() => {
    const getListProductFromRelatedApp = async () => {
      try {
        if (settings.type === "related") {
          const response = await apiService.postRelated(
            "getRelatedForProductInCart",
            {
              action: "getRelatedForProductInCart",
              shop: SHOP,
              listIdProducts: unique(listProductID),
              settings: window.omegaRelatedSettings,
            }
          );
          let productList = [];
          let productListResponse = response.data;
          for (let i = 0; i < productListResponse.length; i++) {
            let data = {
              handle: productListResponse[i].handle,
              image: productListResponse[i].image,
              title: productListResponse[i].title,
              price: productListResponse[i].variants[0]?.price,
              currency: window.Shopify?.currency.active,
            };
            productList.push(data);
          }
          dispatch(setRecommendList(productList));
        }
        return;
      } catch (err) {
        // console.log(err);
      }
    };
    getListProductFromRelatedApp();
  }, [window.omegaRelatedSettings, dispatch]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      paritialVisibilityGutter: 60,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: products.length > 2 ? 2 : products.length,
      paritialVisibilityGutter: 50,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 30,
    },
  };

  return (
    !!products.length && (
      <>
        <div className={`omg-section omg-slide-mobile`}>
          {products?.length !== 0 ? (
            <div className="omg-section__title text-center">
              {settings.title}
            </div>
          ) : (
            ""
          )}
          <div className="omg-section__content">
            <div className="recommend-product-list">
              {products.slice(0, 10).map((product) => (
                <RecommendProduct product={product} key={product.id} />
              ))}
            </div>
          </div>
        </div>
        <div className="omg-slide-desktop">
          {products?.length !== 0 ? (
            <div className="omg-section__title text-center">
              {settings.title}
            </div>
          ) : (
            ""
          )}
          <div
            className="card-group"
            style={{ justifyContent: "space-around" }}
          >
            {products.length > 5 ? (
              <Carousel
                ssr
                partialVisbile
                itemClass="image-item"
                responsive={responsive}
                autoPlay="true"
                autoPlaySpeed={4000}
              >
                {products?.map((product) => (
                  <RecommendProduct product={product} key={product.id} />
                ))}
              </Carousel>
            ) : (
              <div className="omg-section__content">
                <div className="recommend-product-list">
                  {products?.map((product) => (
                    <RecommendProduct product={product} key={product.id} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    )
  );
};

export default RecommendProductList;

function unique(arr) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    if (newArr.indexOf(arr[i]) === -1) {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}
